import * as Config from './config';

// Number of divs required for the animation to function correctly. Must be inside the division with the animation class
var divs = {
    'ball-pulse': 3,
    'ball-grid-pulse': 9,
    'ball-clip-rotate': 1,
    'ball-clip-rotate-pulse': 2,
    'square-spin': 1,
    'ball-clip-rotate-multiple': 2,
    'ball-pulse-rise': 5,
    'ball-rotate': 1,
    'cube-transition': 2,
    'ball-zig-zag': 2,
    'ball-zig-zag-deflect': 2,
    'ball-triangle-path': 3,
    'ball-scale': 1,
    'line-scale': 5,
    'line-scale-party': 4,
    'ball-scale-multiple': 3,
    'ball-pulse-sync': 3,
    'ball-beat': 3,
    'line-scale-pulse-out': 5,
    'line-scale-pulse-out-rapid': 5,
    'ball-scale-ripple': 1,
    'ball-scale-ripple-multiple': 3,
    'ball-spin-fade-loader': 8,
    'line-spin-fade-loader': 8,
    'triangle-skew-spin': 1,
    'pacman': 5,
    'ball-grid-beat': 9,
    'semi-circle-spin': 1,
    'ball-scale-random': 3
};

// Internal state for loaders to determine if the loader should be hidden or not.
var activeProcesses = [];

// Creates the string of empty divs required
var numDivs = _.times(divs[Config.loaderType], () => "<div></div>" ).join('');

/**
 *  Initializes the loading animation. Loader type should be set in the application config.
 * 
 * @returns {object} A jQuery object of the modified loader container
 */
function startLoader() {
    $('#loader-container').html(`<div class="${Config.loaderType}">${numDivs}</div>`);
    return $('#loader-container');
}

/**
 * Shows the loading animation
 * 
 * @param {string} process - An id, usually the name of the calling function, that will identify the process that requires
 * the loader to be showing
 * @returns {array} an array containing all of the active processes that require the loader to be showing
 */
export function showLoader(process) {
    if (!checkForActiveProcess(process)) {
        activeProcesses.push(process);
    }
    $('#loader-container').show();
    return activeProcesses
}

/**
 * Hides the loading animation
 * 
 * @param {string} process - An id, usually the name of the calling function, that will identify the process that requires
 * the loader to be showing
 * @returns {array} an array containing all of the active processes that require the loader to be showing
 */
export function hideLoader(process) {
    if (checkForActiveProcess(process)) {
        activeProcesses = _.pull(activeProcesses, process);
    }
    if (_.isEmpty(activeProcesses)) {
        $('#loader-container').hide();
    }
    return activeProcesses;
}

/**
 * Checks the active state for a particular process
 * 
 * @param {string} process - An id, usually the name of original calling function, that will indentify the process that
 * requires the loader to be showing
 * @returns {boolean} a boolean stating whether or not a process is active (true), or not (false)
 */
function checkForActiveProcess(process) {
    return _.find(activeProcesses, activeProcess => {
        return activeProcess === process;
    });
}

// Initializes the loader
startLoader();


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/loadIndicator.js